import { RoiType } from '@/api/project';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { spendSummaryQueries } from '@/duckdb/spend-summary';

type GeneralSummarySpendQueryArgs = {
    projectId: string;
    startDate: string | undefined;
    endDate: string | undefined;
    roiType: RoiType;
    excludeVariables?: string[];
};

const fetchGeneralSummarySpend = async (
    args: GeneralSummarySpendQueryArgs,
) => {
    const rows = await spendSummaryQueries.getRowsWithContributionProduct({
        ...args,
        period: 'yearly',
    });

    return { rows };
};

export const generalSummarySpendQueryOptions = (
    args: GeneralSummarySpendQueryArgs,
) => {
    return queryOptions({
        queryKey: [
            'generalSummarySpend',
            args.projectId,
            args.startDate,
            args.endDate,
            args.roiType,
            args.excludeVariables,
        ],
        queryFn: () => fetchGeneralSummarySpend(args),
        placeholderData: keepPreviousData,
        staleTime: Infinity,
        enabled: !!args.endDate && !!args.startDate,
    });
};
